// App.js
import React from 'react';
import InvoiceGenerator from './InvoiceGenerator';
import './App.css';

function App() {
  return (
    <div className="App">
      <InvoiceGenerator />
    </div>
  );
}

export default App;